import { createEntityAdapter } from '@reduxjs/toolkit';
import { Application } from '@widgets/cabinet/applicationCard/types';

export const applicationsAdapter = createEntityAdapter<Application>({
  selectId: (application) => application.id,
});
